/**
 * Shared Playbook brand assets / constants (visual only).
 */
export const PLAYBOOK_LOGO = "/playbook-logo.png";
export const PLAYBOOK_BRAND_NAME = "Playbook";
